export default __webpack_public_path__ + "static/media/Nasdaq.b3ec65f1.svg";